<template>
  <div class="studyschemas" data-cy="studyschemas">
    <h4 class="container header ml20">
      {{ $tc('plural.studySchema', 2) }}
    </h4>
    <div class="container">
      <template
        v-for="(studyTask, index) in sortedStudyTasks"
        :key="studyTask.Id"
      >
        <h4
          v-if="
            index === 0 ||
            studyTask.GroupId != sortedStudyTasks[index - 1].GroupId ||
            studyTask.OrganizationId !=
              sortedStudyTasks[index - 1].OrganizationId
          "
          class="sub-header"
        >
          {{ studyTask.Group.DisplayName }}
        </h4>
        <info-row-study-task
          @click="studyTask.Done ? null : goToActivity(studyTask)"
          :study-task="studyTask"
          :style="{ cursor: studyTask.Done ? 'default' : 'pointer' }"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { orderByKeys } from '@/Helpers/sorters';
import InfoRowStudyTask from '../components/InfoRow/InfoRowStudyTask.vue';
import StudyTaskService from '@/Services/StudySchema/StudyTaskService';
import { STUDY_TASK_ACTIONS } from '@/store/modules/studytasks';

export default {
  name: 'StudySchemasView',
  components: {
    InfoRowStudyTask
  },
  props: {},
  data() {
    return {
      studyTasks: []
    };
  },
  mounted() {
    this.getMyStudyTasks();
  },
  methods: {
    ...mapActions('studytasks', {
      $setActiveStudyTask: STUDY_TASK_ACTIONS.SET_ACTIVE_STUDY_TASK
    }),
    getMyStudyTasks() {
      StudyTaskService.getMyStudyTasks().then(studyTasks => {
        this.studyTasks = studyTasks;
      });
    },
    goToActivity(studyTask) {
      this.$setActiveStudyTask(studyTask);
      this.$router.push(studyTask.actionRoute);
    }
  },
  computed: {
    sortedStudyTasks() {
      return orderByKeys(
        this.studyTasks,
        ['GroupId', 'DaysAfterInclusion', 'Priority'],
        ['asc', 'asc', 'asc']
      );
    }
  }
};
</script>

<style lang="scss" scoped>
h4.header {
  margin-top: 3px;
}
</style>
